import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
import CellGroupContext from "./cell-group.context.js";
export function CellGroup(props) {
    const { title, clickable = false, inset = false, bordered = true, children, className, ...restProps } = props;
    return (React.createElement(CellGroupContext.Provider, { value: {
            clickable,
        } },
        React.createElement(View, { className: classNames(prefixClassname("cell-group"), {
                [prefixClassname("cell-group--inset")]: inset,
            }, className), ...restProps },
            title && (React.createElement(View, { className: classNames(prefixClassname("cell-group__title"), {
                    [prefixClassname("cell-group__title--inset")]: inset,
                }), children: title })),
            React.createElement(View, { className: classNames(prefixClassname("cell-group"), {
                    [prefixClassname("hairline--top-bottom")]: bordered,
                }), children: children }))));
}
export default CellGroup;
